import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DriveFolderUploadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drive_folder_upload"}/>
}
